import { render, staticRenderFns } from "./BihamkTemplate.vue?vue&type=template&id=44a9acc6&scoped=true&"
import script from "./BihamkTemplate.vue?vue&type=script&lang=js&"
export * from "./BihamkTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BihamkTemplate.vue?vue&type=style&index=0&id=44a9acc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a9acc6",
  null
  
)

export default component.exports